import { Validators } from '@angular/forms';

export class ValidationService {
    static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
        let config = {
            'required': 'validations.error.required',
            'requiedCaptcha': 'validations.error.not-robot',
            'invalidCreditCard': 'Is invalid credit card number',
            'invalidEmailAddress': 'validations.error.emailError',
            'invalidPassword': 'validators.error.invalidPassword',
            'invalidDigitId': 'validations.error.digitError',
            'invalidOleNumber': 'validations.error.oleNumberError',
            'invalidPhone': 'validations.error.phoneError',
            'invalidId': 'validations.error.idError',
            'invalidText': 'validations.error.textError',
            'invalidEnglishText': 'validations.error.EnglishtextError',
            'invalidHebrewText': 'validations.error.HebrewtextError',
            'invalidDate': 'validations.error.dateError',
            'invalidSpecialCharactes': 'validations.error.SpecialCharactesError',
            'invalidEnglishandNumbers': 'validations.error.invalidEnglishandNumbers',
            'minlength': 'validations.error.minLengthError', 
            'returningDatePassed': 'registration-form.errors.returning_date_passed',
            'returningDateToLate': 'registration-form.errors.returning_date_to_late',
            'returningDateToLate1': 'registration-form.errors.returning_date_to_late1',
            'didntPassed2YearsFrom': 'registration-form.errors.differents_exit_returning_dates',
            'datesDifferenceIsLess17Years': 'registration-form.errors.age_too_litle',
            'datesDifferenceIsLess16Years':'registration-form.errors.age_too_litle16',
            'datesDiffernceBigger18Years': 'registration-form.errors.age_too_big18',
            'fromDateBiggerToDate': 'registration-form.errors.exit_date_biger_returning_date',
            'CheckedRequired': "",
            'CheckExists':'registration-form.errors.existingID',

            "Exsist": "assistance-form.errors.Exsist",
            "ValidStartEndYear":"assistance-form.errors.ValidStartEndYear",
            "startBigger":"assistance-form.errors.startBigger",
            "DomainRequired":"assistance-form.errors.DomainRequired",
            "SetValidators":""
        };

        return config[validatorName];
    }

    static creditCardValidator(control) {
        // Visa, MasterCard, American Express, Diners Club, Discover, JCB
        if (control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
            return null;
        } else {
            return { 'invalidCreditCard': true };
        }
    }

    static IdValidator(control) {
        var idnum = control.value;
        if (!idnum)
            return null;
        if (idnum.match(/^[0|[1-9\s]*$/)) {
            if (idnum.length <= 7) 
                return { 'invalidId': true };

            if (idnum.length < 9)
                idnum = "0" + idnum;

            var idnum1 = Number(idnum.substr(0, 1)) * 1;
            var idnum2 = Number(idnum.substr(1, 1)) * 2;
            var idnum3 = Number(idnum.substr(2, 1)) * 1;
            var idnum4 = Number(idnum.substr(3, 1)) * 2;
            var idnum5 = Number(idnum.substr(4, 1)) * 1;
            var idnum6 = Number(idnum.substr(5, 1)) * 2;
            var idnum7 = Number(idnum.substr(6, 1)) * 1;
            var idnum8 = Number(idnum.substr(7, 1)) * 2;
            var idnum9 = Number(idnum.substr(8, 1)) * 1;

            if (idnum1 > 9) idnum1 = (idnum1 % 10) + 1;
            if (idnum2 > 9) idnum2 = (idnum2 % 10) + 1;
            if (idnum3 > 9) idnum3 = (idnum3 % 10) + 1;
            if (idnum4 > 9) idnum4 = (idnum4 % 10) + 1;
            if (idnum5 > 9) idnum5 = (idnum5 % 10) + 1;
            if (idnum6 > 9) idnum6 = (idnum6 % 10) + 1;
            if (idnum7 > 9) idnum7 = (idnum7 % 10) + 1;
            if (idnum8 > 9) idnum8 = (idnum8 % 10) + 1;
            if (idnum9 > 9) idnum9 = (idnum9 % 10) + 1;
            var sumval = idnum1 + idnum2 + idnum3 + idnum4 + idnum5 + idnum6 + idnum7 + idnum8 + idnum9;
            sumval = sumval % 10;
            return sumval > 0 ? { 'invalidId': true } : null;
        } 
        return (idnum == "") ? null : { 'invalidId': true };
    }
    
    static dateValidator(control) {
        if (control.value.match(/^((((19|[2-9]\d)\d{2})\-(0[13578]|1[02])\-(0[1-9]|[12]\d|3[01]))|(((19|[2-9]\d)\d{2})\-(0[13456789]|1[012])\-(0[1-9]|[12]\d|30))|(((19|[2-9]\d)\d{2})\-02\-(0[1-9]|1\d|2[0-8]))|(((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))\-02\-29))$/)) {
            var l = control.value;
            var y = l.substr(0, 4);
            var m = l.substr(5, 2);
            var d = l.substr(8, 2);
            var dres = m.match(/^(\d){2}$/);
            if (!dres)
                m = l.substr(6, 2);
            var newDate = d + "/" + m + "/" + y;
            if (newDate.match(/^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/)) {
                var currentDate = new Date();
                var dateParts = [];
                dateParts = newDate.split("/");
                var date = new Date(dateParts[2], (dateParts[1] - 1), dateParts[0]);
                if ((new Date(currentDate) > new Date(date)) && (new Date(currentDate).getUTCFullYear() - 100 < new Date(date).getUTCFullYear()))
                    return null;
                else
                    return { 'invalidDate': true };
            }
            else
                return { 'invalidDate': true };
        }
        else {
            return { 'invalidDate': true };
        }
    }
    static AlyiaDateValidator(control) {
        if (control.value == "")
            return null;
        if (control.value.match(/^((((19|[2-9]\d)\d{2})\-(0[13578]|1[02])\-(0[1-9]|[12]\d|3[01]))|(((19|[2-9]\d)\d{2})\-(0[13456789]|1[012])\-(0[1-9]|[12]\d|30))|(((19|[2-9]\d)\d{2})\-02\-(0[1-9]|1\d|2[0-8]))|(((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))\-02\-29))$/)) {
            var l = control.value;
            var y = l.substr(0, 4);
            var m = l.substr(5, 2);
            var d = l.substr(8, 2);
            var dres = m.match(/^(\d){2}$/);
            if (!dres)
                m = l.substr(6, 2);
            var newDate = d + "/" + m + "/" + y;
            if (newDate.match(/^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/)) {
                var currentDate = new Date();
                var dateParts = [];
                dateParts = newDate.split("/");
                var date = new Date(dateParts[2], (dateParts[1] - 1), dateParts[0]);
                if ((new Date(currentDate) < new Date(date)) && (new Date(currentDate).getUTCFullYear() + 100 > new Date(date).getUTCFullYear()))
                    return null;
                else
                    return { 'invalidDate': true };
            }
            else
                return { 'invalidDate': true };
        }
        else {
            return { 'invalidDate': true };
        }
    }
    static textValidator(control) {
        if (control.value.match(/^['àâçéèêëîïôûùüÿñÑíóúа-яА-Яa-zA-Zא-ת\s]*$/)) {
            return null;
        } else {
            return { 'invalidText': true };
        }
    }
    static textEnglishValidator(control) {
        if (control.value.match(/^[a-zA-Z\-\s]*$/)) {
            return null;
        } else {
            return { 'invalidEnglishText': true };
        }
    }
    static textHebrewValidator(control) {
        if (control.value.match(/^[א-ת'\-\s]*$/)) {
            return null;
        } else {
            return { 'invalidHebrewText': true };
        }
    }
    static specialCharactesValidator(control) {
        if (control.value.match(/[~*^`{}|<>]/)) {
            return { 'invalidSpecialCharactes': true };
        } else {
            return null;
        }
    }
    static OleNumberValidator(control) {
        if (control.value.match(/^[0|[1-9\s]*$/)) {
            return null;
        } else {
            return { 'invalidOleNumber': true };
        }
    }

    static EnglishandNumbersValidator(control) {
        if (control.value.match(/^[a-zA-Z0-9\s]*$/)) {
            return null;
        } else {
            return { 'invalidEnglishandNumbers': true };
        }
    }

    static phoneValidator(control) {
        if (control.value == "")
            return null;
        if (control.value.match(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/)) {
            return null;
        } else {
            return { 'invalidPhone': true };
        }
    }

    static emailValidator(control) {
        // RFC 2822 compliant regex
        if (control.value.match(/^[-\w\.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
            return null;
        } else {
            return { 'invalidEmailAddress': true };
        }
    }

    static passwordValidator(control) {
        // {6,100}           - Assert password is between 6 and 100 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
            return null;
        } else {
            return { 'invalidPassword': true };
        }
    }

    static captchaValidator(control) {

        if (control.value == "valid") {
            return null;
        } else {
            return { 'requiedCaptcha': true };
        }
    }

    static returningDatePassedValidator(control) {
        if (!control)
            return null;
        let maxdate = new Date();

        if (new Date(control.value) >= maxdate) {
            return null;
        } else {
            return { 'returningDatePassed': true };
        }
    }

    static returningDateToLateValidator(control, IsScientist) {
        if (!control)
            return null;
        let maxdate = new Date();
        if (IsScientist)
            maxdate.setFullYear(maxdate.getFullYear() + 1);
        else
            maxdate.setMonth(maxdate.getMonth() + 6);
        if (new Date(control.value) < maxdate) {
            return null;
        } else {
            return IsScientist ? { 'returningDateToLate1': true } : { 'returningDateToLate': true };
        }
    }

    static didntPassed2YearsFromValidator(control, control2) {
        if (!control2 || control.value == "" || control2.value == "")
            return null;
        let from = new Date(control2.value);
        from.setFullYear(from.getFullYear() + 2);
        from.setHours(0);
        from.setMinutes(0);
        from.setSeconds(0);
        if (new Date(control.value) >= from) {
            return null;
        } else {
            return { 'didntPassed2YearsFrom': true };
        }
    }

    static datesDiffernceLess17Years(control, control2) {
        if (!control2 || control.value == "" || control2.value == "")
            return null;
        let from = new Date(control2.value);
        let to = new Date(control.value);
        from.setFullYear(from.getFullYear() + 17);
        from.setHours(0);
        from.setMinutes(0);
        from.setSeconds(0);
        if (to >= from) {
            return null;
        } else {
            return { 'datesDifferenceIsLess17Years': true };
        }
    }
    
    static datesDiffernceLess16Years(control, control2)
    {
        if (!control2 || control.value == "" || control2.value == "")
            return null;
        let from = new Date(control2.value);
        let to = new Date(control.value);
        from.setFullYear(from.getFullYear() + 16);
        from.setHours(0);
        from.setMinutes(0);
        from.setSeconds(0);
        if (to >= from) {
            return null;
        } else {
            return { 'datesDifferenceIsLess16Years': true };
        }
    }

    static datesDiffernceBigger18Years(control, control2)
    {
        if (!control2 || control.value == "" || control2.value == "")
            return null;
        let from = new Date(control2.value);
        let to = new Date(control.value);
        to.setFullYear(to.getFullYear() - 18);
        to.setHours(0);
        to.setMinutes(0);
        to.setSeconds(0);
        if (to <= from) {
            return null;
        } else {
            return { 'datesDiffernceBigger18Years': true };
        }
    }
    
    static FromDateBiggerToDate(control, control2)
    {
        if (!control2 || control.value == "" || control2.value == "")
            return null;
        let from = new Date(control2.value);
        let to = new Date(control.value);
        from.setHours(0);
        from.setMinutes(0);
        from.setSeconds(0);
        if (to > from) {
            return null;
        } else {
            return { 'fromDateBiggerToDate': true };
        }
    }

    static CheckedRequired(control) {
        if (control.value == true)
            return null;
        else {
            return { 'CheckedRequired': true };
        }
    }

    static DomainRequired(control) {
        if (control.value != "")
            return null;
        else {
            return { 'DomainRequired': true };
        }
    }  
    static compareEducation(control1, control2) {
        if (control1.DegreeCertificate.value == control2.DegreeCertificate.value &&
            control1.studyField.value == control2.studyField.value)
            return { 'Exsist': true };
        return null;
    }

    static compareProfession(control1, control2) {
        if (control1.subjectField.value == control2.subjectField.value &&
            control1.subject.value == control2.subject.value)
            return { 'Exsist': true };
        return null;
    }

    static validStartEndYear(control) {
        if (control.value > 1900 && control.value <= (new Date()).getFullYear())
            return null;
        return { 'ValidStartEndYear': true };

    }
    static compareStartEndYear(control) {
        let parent = control.parent;
        let err = {'startBigger': true};
        let startD = parent.controls.startYear;
        let endD = parent.controls.endYear;
        if (((startD.value as string).length == 4) && ((endD.value as string).length == 4) && (startD.value > endD.value)) {
            if (control == startD)
                endD.setErrors(err);
            else 
                return err;
        }
            
        return null;

    }

    static compareExperience(control1, control2) {
        return (control1.domain.value == control2.domain.value &&
            control1.job.value == control2.job.value && 
            control1.startYear.value == control2.startYear.value &&
            control1.endYear.value == control2.endYear.value&&
            control1.workPlace.value == control2.workPlace.value
        ) ? { 'Exsist': true } : null;
    }
    
    static CheckExists (control, isMark){
        if (control.value == "" || isMark == "1" )
            return null;
        return { 'CheckExists': true };
    }

    static DateRequired(control) {
        if (control.value) {
            if (control.value.getDate)
                return null;
            let val = control.value.trim().toUpperCase();
            if ((val != "") && (val != 'INVALID DATE')) 
                return null;
        }
        return { 'required': true };        
    }

    static SetValidators (control, validations = [Validators.required]) {
        let val  = control.value;
        control.setValidators(validations);
        control.setValue('');
        control.setValue(val);
    }
     
    
}